export interface Line {
  id: string
  lineNumber: string
  lineName: string
  createdAt: Date
}

export function createLine(lineNumber: string, lineName: string): Line {
  return {
    id: Math.random().toString(36).substr(2, 9),
    lineNumber,
    lineName,
    createdAt: new Date(),
  }
}
